import { PrinterOutlined } from '@ant-design/icons';
import { useTranslate } from '@tolgee/react';
import { Button } from 'antd';
import React from 'react';
import { useReactToPrint } from 'react-to-print';

import DownloadIcon from '../../../assets/icons/download.svg';

interface Props {
  printRef: React.RefObject<HTMLDivElement>;
  documentTitle?: string;
  buttonText?: string;
  shape?: 'circle' | 'round' | 'default';
  icon?: React.ReactNode;
  onBeforePrint?: () => void;
  onAfterPrint?: () => void;
  type?: any;
  loading: any;
}

const PrintButton: React.FC<Props> = ({
  printRef,
  documentTitle = 'Print',
  buttonText = '',
  shape = 'circle',
  icon = <PrinterOutlined />,
  onBeforePrint = () => {},
  onAfterPrint = () => {},
  type = 'primary',
  loading,
}) => {
  const { t } = useTranslate();
  const handlePrint = useReactToPrint({
    content: () => printRef.current,
    documentTitle,
    onBeforePrint: () => {
      onBeforePrint?.();
    },
    onAfterPrint: () => {
      onAfterPrint?.();
    },
    pageStyle: `
    @media print {
      body {
        -webkit-print-color-adjust: exact !important;
        print-color-adjust: exact !important;
        font-family: sans-serif;
      }
  
      header, footer {
        display: none !important;
      }
  
      table {
        width: 100%;
        border-collapse: collapse;
      }
  
      thead {
        display: table-header-group;
      }
  
      tfoot {
        display: table-footer-group;
      }
  
      tr, td, th {
        page-break-inside: avoid !important;
      }
  
      th, td {
        padding: 4px 8px;
        border: 1px solid #ccc;
        text-align: left;
      }
  
      .display-for-print {
        display: block !important;
      }
  
      .not-display-for-print {
        display: none !important;
      }
    }
  `,
  });

  return (
    <Button
      className='analytics-section-header-download'
      disabled={loading}
      onClick={() => handlePrint?.()}
    >
      {!loading && <img src={DownloadIcon} alt='' />}
      <p>{loading ? 'Downloading' : t('download')}</p>
    </Button>
  );
};

export default PrintButton;
